import { Paper } from '@material-ui/core'
import React from 'react'
import { tenItemPersonalityInventory } from '../data'
import TIPIQuestion from './component'
const TIPIs = () => {
    return (
        <Paper elevation={5} style={{ background: '#dfdfdf', padding: '20px', minWidth: '500px' }}>
            <h2>The Ten Item Personality Inventory</h2>
            I see myself as:
            {tenItemPersonalityInventory.map((value, key) => (
                <TIPIQuestion id={key} key={key} question={value} />
            ))}
        </Paper>
    )
}


export default TIPIs